module.exports = __webpack_public_path__ + "static/media/icon_education.2942fe40.svg";